import * as z from 'zod';

export const RunTriggerRequest = z.object({
  options: z
    .object({
      triggerId: z
        .string()
        .describe(
          'Trigger ID. You can find this in the custom trigger configuration in the automations builder.'
        )
        .max(100)
        .optional(),
      payload: z
        .record(z.string(), z.any())
        .describe(
          'Optional payload object to pass to run trigger. Define the payload schema from sample data in the custom trigger configuration in the\nautomations builder.'
        )
        .optional()
        .nullable(),
    })
    .optional(),
});
export const RunTriggerResponse = z.object({});
